module.exports = __webpack_public_path__ + "static/pauserecording5-d07abf9ceaaa57be3574ee337f1aac1a.png";